"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsGridSection = exports.showContestError = exports.setNewResults = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var OnlineOfflineMode_1 = require("icf-search-client-shared/lib/constants/OnlineOfflineMode");
var RecommenderSession_1 = require("icf-search-client-shared/lib/services/RecommenderSession");
var XmentService_1 = require("icf-search-client-shared/lib/services/XmentService");
var react_1 = __importStar(require("react"));
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var ContestLogin_1 = require("./ContestLogin");
var ContestResultsError_1 = require("./ContestResultsError");
var HeroSpaceGridCard_1 = require("./HeroSpaceGridCard");
var PerformerItemContainer_1 = require("./PerformerItemContainer");
var PerformerList_1 = require("./PerformerList");
var SearchResultsError_1 = require("./SearchResultsError");
var SearchResultsGridHelpers_1 = require("./SearchResultsGridHelpers");
var MAX_GRID_CLICKS = 100;
var GRID_CLICKS_STORAGE_KEY = "gridClicks";
var newResults = false;
var setNewResults = function (newResult) {
    newResults = newResult;
};
exports.setNewResults = setNewResults;
var gridClicksMap = new Map();
var appendNewGridClick = function (performerId) {
    if (gridClicksMap.has(performerId)) {
        gridClicksMap.delete(performerId);
    }
    gridClicksMap.set(performerId, true);
    var oldest = gridClicksMap.keys().next().value;
    if (gridClicksMap.size > MAX_GRID_CLICKS && oldest) {
        gridClicksMap.delete(oldest);
    }
};
(function initializeFromStorage() {
    var e_1, _a;
    var previousGridClicks = sessionStorage.getItem(GRID_CLICKS_STORAGE_KEY);
    if (previousGridClicks) {
        try {
            for (var _b = __values(previousGridClicks.split(",")), _c = _b.next(); !_c.done; _c = _b.next()) {
                var performerId = _c.value;
                appendNewGridClick(performerId);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
})();
var breakpointColumnGutters = {
    small: 2,
    medium: 2,
    large: 4,
};
var showContestError = function (queryOptions, resultsContext) {
    if (queryOptions.type !== "contest") {
        return false;
    }
    else if (!queryOptions.contestInfo) {
        return true;
        // Was this written as if this was observable?
    }
    else if (!(resultsContext === null || resultsContext === void 0 ? void 0 : resultsContext.value)) {
        return true;
    }
    else if (resultsContext.value.isLoadingInitialResults) {
        return false;
    }
    else if (resultsContext.value.totalItemCount === 0 || resultsContext.value.isFallback) {
        return true;
    }
    return false;
};
exports.showContestError = showContestError;
var SearchResultsGridSection = function (_a) {
    var breakpoint = _a.breakpoint, currentCategory = _a.currentCategory, dataSource = _a.dataSource, emitTrackingEvent = _a.emitTrackingEvent, heroBannerImage = _a.heroBannerImage, isFirstGrid = _a.isFirstGrid, isLogoVerified = _a.isLogoVerified, isSoundEnabled = _a.isSoundEnabled, logger = _a.logger, navigation = _a.navigation, onJoinClicked = _a.onJoinClicked, onLoginClicked = _a.onLoginClicked, onlineOfflineMode = _a.onlineOfflineMode, onOfflineButtonClicked = _a.onOfflineButtonClicked, onNotifyClicked = _a.onNotifyClicked, openJoinModal = _a.openJoinModal, queryOptions = _a.queryOptions, setIsGridErrored = _a.setIsGridErrored, showHeadlines = _a.showHeadlines, statsdClient = _a.statsdClient, thumbnailSize = _a.thumbnailSize, translate = _a.translate, user = _a.user, xmentService = _a.xmentService, onNoOnlineResultsRedirect = _a.onNoOnlineResultsRedirect, pushRoute = _a.pushRoute;
    var _b = __read((0, Ioc_1.useContexts)(Contexts_1.IRouterContext), 1), router = _b[0];
    var isHeroBannerOnGrid = currentCategory === "allgirls" && (xmentService === null || xmentService === void 0 ? void 0 : xmentService.isXmentVariationOn(XmentService_1.SEARCH_FREE_ACCOUNT_SIGN_UP_TILE_XMENT_NAME));
    if (queryOptions.type === "contest") {
        statsdClient.count("searchResults.view_contest_total");
        if (!user || !user.isAuthenticated) {
            return (0, jsx_runtime_1.jsx)(ContestLogin_1.ContestLogin, { onLoginClicked: onLoginClicked, onJoinClicked: onJoinClicked, translate: translate });
        }
        else if ((0, exports.showContestError)(queryOptions, dataSource.resultsContext)) {
            statsdClient.count("searchResults.view_contest_error");
            return (0, jsx_runtime_1.jsx)(ContestResultsError_1.ContestResultsError, { translate: translate, onTryAgainClicked: function () { return dataSource.reset(); } });
        }
    }
    if (user && user.country) {
        queryOptions.country = user.country;
    }
    if (navigation && navigation.path === "/view/recents" && statsdClient) {
        statsdClient.count("searchResults.view_recents_total");
    }
    if (!(0, SearchResultsGridHelpers_1.shouldShowPerformerGrid)(dataSource.resultsContext.value.errors)) {
        return (0, jsx_runtime_1.jsx)("div", {});
    }
    if (dataSource.resultsContext.value.currentError) {
        logger && logger.error("Failed to get search results", dataSource.resultsContext.value.currentError);
        addStatsdForErrors(queryOptions, navigation, statsdClient);
        setIsGridErrored && setIsGridErrored(true);
        return (0, jsx_runtime_1.jsx)(SearchResultsError_1.SearchResultsError, { onTryAgainClicked: function () { return dataSource.reset(); }, translate: translate });
    }
    setIsGridErrored && setIsGridErrored(false);
    var currentPerformerItem = (0, react_1.useRef)(null);
    var onGridClick = function (performerId) {
        var previousLastGridClick = sessionStorage.getItem("lastGridClick");
        (0, exports.setNewResults)(previousLastGridClick !== performerId);
        sessionStorage.setItem("lastGridClick", performerId);
        appendNewGridClick(performerId);
        sessionStorage.setItem(GRID_CLICKS_STORAGE_KEY, Array.from(gridClicksMap.keys()).join(","));
    };
    (0, react_1.useEffect)(function () {
        dataSource.resultsContext.subscribe(function () {
            var _a, _b;
            var resultsContext = dataSource.resultsContext.value;
            var filters = queryOptions.filters;
            var pathname = (_a = router === null || router === void 0 ? void 0 : router.location) === null || _a === void 0 ? void 0 : _a.pathname;
            var isHomePage = [
                "/",
                "/browse/livesex/allgirls",
                "/browse/guycams/allguys",
                "/browse/transcams/alltrans",
                "/page/1",
                "/browse/livesex/allgirls/page/1",
                "/browse/guycams/allguys/page/1",
                "/browse/transcams/alltrans/page/1",
            ].includes(pathname);
            var isUnfilteredHomepage = ((_b = filters === null || filters === void 0 ? void 0 : filters.advanced) === null || _b === void 0 ? void 0 : _b.every(function (filter) { return filter.options.every(function (option) { return !option.isChecked; }); })) && isHomePage;
            var isOnlineOnlyDisabledPage = queryOptions.type === "favorites" || queryOptions.type === "contest";
            if (resultsContext.isFallback &&
                onlineOfflineMode === OnlineOfflineMode_1.ONLINE_OFFLINE_MODE_ONLINE &&
                onOfflineButtonClicked &&
                !isUnfilteredHomepage &&
                !isOnlineOnlyDisabledPage &&
                !dataSource.resultsContext.value.isLoadingInitialResults) {
                onOfflineButtonClicked();
                onNoOnlineResultsRedirect === null || onNoOnlineResultsRedirect === void 0 ? void 0 : onNoOnlineResultsRedirect();
            }
            var experimentName = (0, RecommenderSession_1.getRecommenderSession)().experimentName;
            if (!isHomePage && experimentName && experimentName.startsWith("lastGridClick") && newResults && pushRoute) {
                var newPage = pathname.split("/page")[0];
                pushRoute(newPage);
            }
            (0, exports.setNewResults)(false);
        });
    }, []);
    // TODO: This shouldn't be an issue because the item should never be unmounted and remounted while the user is hovering over it
    var swapRollovers = function (newPerformerItem) {
        if ((currentPerformerItem === null || currentPerformerItem === void 0 ? void 0 : currentPerformerItem.current) &&
            currentPerformerItem.current.getPerformerId() !== newPerformerItem.getPerformerId()
        // Only stop the rollover if the new performerItem is different than the last (important for compatibility with desktop)
        ) {
            currentPerformerItem.current.stopRollover();
        }
        currentPerformerItem.current = newPerformerItem;
    };
    var MAX_DUP_RETRIES = 3;
    var dupRangeAttemptsRef = react_1.default.useRef(new Map());
    var dedupeInFlightRef = react_1.default.useRef(false);
    // Helpers
    var expandToChunkRange = function (startAbs, endAbsExclusive, pageSize) {
        if (!pageSize || pageSize <= 0)
            return { start: startAbs, end: endAbsExclusive };
        var startChunk = Math.floor(startAbs / pageSize);
        var endChunk = Math.floor((endAbsExclusive - 1) / pageSize);
        var s = startChunk * pageSize;
        var e = (endChunk + 1) * pageSize;
        // Only pull an extra trailing chunk if the duplicate group crosses a seam
        if (endChunk > startChunk)
            e += pageSize;
        return { start: s, end: e };
    };
    var mergeRanges = function (ranges) {
        if (ranges.length === 0)
            return [];
        var sorted = ranges.slice().sort(function (a, b) { return (a.start === b.start ? a.end - b.end : a.start - b.start); });
        var merged = [];
        var cur = __assign({}, sorted[0]);
        for (var i = 1; i < sorted.length; i++) {
            var r = sorted[i];
            if (r.start <= cur.end) {
                cur.end = Math.max(cur.end, r.end);
            }
            else {
                merged.push(cur);
                cur = __assign({}, r);
            }
        }
        merged.push(cur);
        return merged;
    };
    var checkAndRepairDuplicates = react_1.default.useCallback(function () {
        var e_2, _a, e_3, _b, e_4, _c, e_5, _d;
        var _e, _f, _g, _h;
        // Avoid overlapping runs (interval or manual)
        if (dedupeInFlightRef.current)
            return;
        // Current visible index range in the datasource
        var itemRange = dataSource.itemRange.value;
        var visibleCount = Math.max(0, itemRange.end - itemRange.start);
        if (visibleCount === 0)
            return;
        // Grab all currently visible items (+1 sentinel at the edge for seam-crossing dupes)
        var visibleItems = Array.from(dataSource.getItemsInRange({ start: 0, end: visibleCount + 1 }));
        // Count how many times each performer ID appears
        var performerIdCounts = {};
        try {
            for (var visibleItems_1 = __values(visibleItems), visibleItems_1_1 = visibleItems_1.next(); !visibleItems_1_1.done; visibleItems_1_1 = visibleItems_1.next()) {
                var item = visibleItems_1_1.value;
                var performerId = item === null || item === void 0 ? void 0 : item.id;
                if (performerId != null) {
                    performerIdCounts[performerId] = ((_e = performerIdCounts[performerId]) !== null && _e !== void 0 ? _e : 0) + 1;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (visibleItems_1_1 && !visibleItems_1_1.done && (_a = visibleItems_1.return)) _a.call(visibleItems_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        // Collect absolute indexes for any performer IDs that appear more than once
        var duplicateIndicesById = new Map();
        visibleItems.forEach(function (item, idx) {
            var _a;
            var performer = item;
            if (!(performer === null || performer === void 0 ? void 0 : performer.hasDetails))
                return;
            var performerId = performer.id;
            if (performerId == null)
                return;
            var isDuplicate = performerIdCounts[performerId] > 1;
            if (isDuplicate) {
                var absoluteIndex = itemRange.start + idx;
                var indices = (_a = duplicateIndicesById.get(performerId)) !== null && _a !== void 0 ? _a : [];
                indices.push(absoluteIndex);
                duplicateIndicesById.set(performerId, indices);
            }
        });
        if (duplicateIndicesById.size === 0)
            return; // No duplicates found
        // Build widened refresh ranges around each duplicate group
        var dsAny = dataSource;
        var pageSize = (_f = dsAny._pageSize) !== null && _f !== void 0 ? _f : dsAny.pageSize;
        var widenedRanges = [];
        try {
            for (var duplicateIndicesById_1 = __values(duplicateIndicesById), duplicateIndicesById_1_1 = duplicateIndicesById_1.next(); !duplicateIndicesById_1_1.done; duplicateIndicesById_1_1 = duplicateIndicesById_1.next()) {
                var _j = __read(duplicateIndicesById_1_1.value, 2), duplicateIndices = _j[1];
                if (duplicateIndices.length < 2)
                    continue; // not actually a duplicate group
                var minIndex = Math.min.apply(Math, __spreadArray([], __read(duplicateIndices), false));
                var maxIndexExclusive = Math.max.apply(Math, __spreadArray([], __read(duplicateIndices), false)) + 1;
                widenedRanges.push(expandToChunkRange(minIndex, maxIndexExclusive, pageSize));
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (duplicateIndicesById_1_1 && !duplicateIndicesById_1_1.done && (_b = duplicateIndicesById_1.return)) _b.call(duplicateIndicesById_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        // Merge overlapping ranges to minimize redundant refreshes
        var mergedRanges = mergeRanges(widenedRanges);
        if (mergedRanges.length === 0)
            return;
        // Skip ranges that have already hit the retry budget
        var rangesToRepair = [];
        try {
            for (var mergedRanges_1 = __values(mergedRanges), mergedRanges_1_1 = mergedRanges_1.next(); !mergedRanges_1_1.done; mergedRanges_1_1 = mergedRanges_1.next()) {
                var range = mergedRanges_1_1.value;
                var key = "".concat(range.start, "-").concat(range.end);
                var attempts = (_g = dupRangeAttemptsRef.current.get(key)) !== null && _g !== void 0 ? _g : 0;
                if (attempts >= MAX_DUP_RETRIES)
                    continue;
                dupRangeAttemptsRef.current.set(key, attempts + 1);
                rangesToRepair.push(range);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (mergedRanges_1_1 && !mergedRanges_1_1.done && (_c = mergedRanges_1.return)) _c.call(mergedRanges_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        if (rangesToRepair.length === 0)
            return;
        // Flag that we’re actively deduping
        dedupeInFlightRef.current = true;
        var release = function () {
            dedupeInFlightRef.current = false;
        };
        try {
            var refreshPromises = [];
            try {
                for (var rangesToRepair_1 = __values(rangesToRepair), rangesToRepair_1_1 = rangesToRepair_1.next(); !rangesToRepair_1_1.done; rangesToRepair_1_1 = rangesToRepair_1.next()) {
                    var range = rangesToRepair_1_1.value;
                    if (typeof dsAny.refreshRange === "function") {
                        var entry = dsAny.refreshRange({ start: range.start, end: range.end });
                        var pagePromise = (_h = entry === null || entry === void 0 ? void 0 : entry.pagePromise) === null || _h === void 0 ? void 0 : _h.promise;
                        if (pagePromise === null || pagePromise === void 0 ? void 0 : pagePromise.finally) {
                            refreshPromises.push(pagePromise);
                        }
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (rangesToRepair_1_1 && !rangesToRepair_1_1.done && (_d = rangesToRepair_1.return)) _d.call(rangesToRepair_1);
                }
                finally { if (e_5) throw e_5.error; }
            }
            if (refreshPromises.length > 0) {
                Promise.allSettled(refreshPromises).finally(release);
            }
            else {
                // Fallback: if no promises, release after a short delay
                setTimeout(release, 400);
            }
        }
        catch (_k) {
            release();
        }
    }, [dataSource]);
    var runDupeScan = react_1.default.useCallback(function () {
        checkAndRepairDuplicates();
    }, [checkAndRepairDuplicates]);
    useIntervalDedupe(dataSource, runDupeScan, 1000, 200);
    return ((0, jsx_runtime_1.jsx)(PerformerList_1.PerformerList, { dataSource: dataSource, layout: __assign(__assign({ type: "optimalWidthGrid" }, (0, SearchResultsGridHelpers_1.getWidthAndColumns)(thumbnailSize)), { cellRatio: 3 / 4, gutter: breakpointColumnGutters[breakpoint] }), itemRenderer: function (performerData, itemIndex) {
            if (isHeroBannerOnGrid &&
                itemIndex === 5 &&
                breakpoint !== "large" &&
                dataSource.itemRange.value.start === 0 &&
                isFirstGrid &&
                !user.isAuthenticated) {
                return (0, jsx_runtime_1.jsx)(HeroSpaceGridCard_1.HeroSpaceGridCard, { heroBannerImage: heroBannerImage });
            }
            return ((0, jsx_runtime_1.jsx)(PerformerItemContainer_1.PerformerItemContainer, { breakpoint: breakpoint, dataSource: dataSource, dataQueryOptions: queryOptions, emitTrackingEvent: emitTrackingEvent, getPerformerLinkTo: navigation.getPerformerLinkTo, isLogoVerified: isLogoVerified, isMobile: breakpoint !== "large", itemIndex: itemIndex, isSoundEnabled: isSoundEnabled, onNotifyClicked: onNotifyClicked, openJoinModal: openJoinModal, performerData: performerData, showHeadlines: showHeadlines, swapRollovers: swapRollovers, onGridClick: onGridClick }, "performerItem" + itemIndex));
        } }));
};
exports.SearchResultsGridSection = SearchResultsGridSection;
function useIntervalDedupe(dataSource, onTick, intervalMs, jitterMs) {
    if (intervalMs === void 0) { intervalMs = 1500; }
    if (jitterMs === void 0) { jitterMs = 0; }
    var timerRef = react_1.default.useRef(null);
    var lastRunRef = react_1.default.useRef(0);
    react_1.default.useEffect(function () {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
        var safeTick = function () {
            if (typeof document !== "undefined" && document.visibilityState !== "visible")
                return;
            var rc = dataSource.resultsContext.value;
            if (!rc || rc.isLoadingInitialResults || rc.currentError)
                return;
            var now = Date.now();
            if (now - lastRunRef.current < intervalMs - 5)
                return;
            lastRunRef.current = now;
            onTick();
        };
        // No leading-edge call; wait until after the first interval to avoid initial paint interference.
        var actualMs = intervalMs + (jitterMs ? Math.floor(Math.random() * jitterMs) : 0);
        timerRef.current = window.setInterval(safeTick, actualMs);
        return function () {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [dataSource, onTick, intervalMs, jitterMs]);
}
// TODO: Typings
function addStatsdForErrors(queryOptions, navigation, statsdClient) {
    if (!statsdClient) {
        return;
    }
    statsdClient.count("searchResults.data_source_failed");
    if (queryOptions && queryOptions.type === "contest") {
        statsdClient.count("searchResults.view_contest_failed");
    }
    if (navigation && navigation.path === "/view/recents") {
        statsdClient.count("searchResults.view_recents_failed");
    }
}
exports.SearchResultsGridSection.displayName = "SearchResultsGridSection";
//# sourceMappingURL=SearchResultsGridSection.js.map